<template>
  <div>
    <div
      class="bg-grey mt-4 mb-2 pb-0 award-sort row"
      :class="{ open: filtersVisible }"
    >
      <div class="col-5 mb-3">
        <button class="button--link" @click="toggleFilters" v-if="categories.length">
          {{ translate("lblLimitList") }}
          <span class="s s-arrow-down ml-2"></span>
        </button>
      </div>
      <div class="col-7 mb-3 text-right">
        <select class="ml-2" @change="filterAndSortAwards" v-model="order" name="sort">
          <option v-for="option in sortOptions" :key="option.name" :value="option.name" v-text="translate(`lblSort${option.name}`)"></option>
        </select>
      </div>
    </div>
    <div class="bg-white award-filter mb-4 pb-0" v-show="filtersVisible" v-if="categories.length">
      <h3 class="h3 bold" v-text="translate('lblFilterEntries')"></h3>
      <ul class="mb-0">
        <li v-for="category in categories" :key="category">
          <input
            type="checkbox"
            :id="category.toLowerCase()"
            :value="category"
            v-model="checkedFilters"
            @change="filterAndSortAwards"
          />
          <label :for="category.toLowerCase()">{{ category }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AwardFilter',
  data: () => ({
    checkedFilters: [],
    categories: [],
    filtersVisible: false,
    order: 'Date',
    sortOptions: null,
  }),
  props: {
    products: Array,
    locale: String,
    start: Number,
  },
  methods: {
    filterAwards(awards) {
      const returnValue = this.checkedFilters.length ? awards.filter((award) => {
        let includesCategory = false;
        for (let index = 0; index < this.checkedFilters.length; index += 1) {
          const filter = this.checkedFilters[index];
          if (award.category && award.category.includes(filter)) {
            includesCategory = true;
            break;
          }
        }
        return includesCategory;
      }) : awards;
      return returnValue;
    },
    setCategories() {
      const categorySet = new Set([]);
      this.products.forEach((product) => {
        if (!product.category) return;
        product.category.forEach((category) => {
          categorySet.add(category);
        });
      });

      this.categories = [...categorySet];
    },
    toggleFilters() {
      this.filtersVisible = !this.filtersVisible;
      this.filterAndSortAwards(); // todo: remove after debugging
    },
    sortAwards(awards) {
      awards.sort(this.sortOptions.find((o) => o.name === this.order).fn);
      return awards;
    },
    filterAndSortAwards() {
      this.$emit('update-product-list', { products: this.sortAwards(this.filterAwards(this.products)), start: performance.now() });
    },
  },
  created() {
    this.sortOptions = [
      {
        name: 'Date',
        fn: (a, b) => new Date(b.created_at) - new Date(a.created_at),
      },
      {
        name: 'Name',
        fn: (a, b) => a.teaser_title.localeCompare(b.teaser_title, this.locale, { sensitivity: 'base' }),
      },
      {
        name: 'Points',
        fn: (a, b) => a.points - b.points,
      },
    ];
    this.setCategories();
    this.filterAndSortAwards();
  },
  computed: {},
};
</script>

<style lang="scss">
.award-sort {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: nowrap;

  .s-arrow-down {
    display: inline-block;
    transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  }

  select {
    width: auto;
    padding-right: 5rem;

    @media (min-width: rem(768)) {
      padding-right: 8rem;
    }
  }

  &.open {
    .s-arrow-down {
      transform: rotate(-180deg);
    }
  }
}

.award-filter {
  padding: rem(20);

  h3 {
    font-size: 1rem;
    margin-bottom: rem(20);
  }

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;

    li {
      padding: 0;
      margin: 0;
      margin-bottom: rem(20);
      flex: 1 0 100%;
      display: flex;

      @media (min-width: rem(768)) {
        flex: 0 0 50%;
      }

      @media (min-width: rem(1280)) {
        flex: 0 0 25%;
      }
    }

    input {
      display: none;
    }

    label {
      padding: 0 0 0 rem(32px);
      position: relative;
    }
  }

  input[type="checkbox"] + label::before {
    width: rem(20px);
    height: rem(20px);
    border: 2px solid #ff6c00;
    background-color: #fff;
    display: block;
    content: "";
    position: absolute;
    left: 0;
  }

  input[type="checkbox"]:checked + label::before {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4gIDxnIGZpbGw9Im5vbmUiPiAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiNGRjZDMDAiLz4gICAgPHBvbHlnb24gZmlsbD0iI0ZGRiIgcG9pbnRzPSI4LjY4OCAxMi44MyA0LjkzNyA5LjgyOSAzLjA2MyAxMi4xNzEgOS4zMTIgMTcuMTcgMTcuMjI5IDUuODYgMTQuNzcxIDQuMTQiLz4gIDwvZz48L3N2Zz4=);
    border: 0;
  }
}
</style>
